import React from "react";

interface FlowentiIconProps {
    className?: string;
    filled?: boolean;
}
const FlowentiIcon: React.FC<FlowentiIconProps> = ({
    className = "",
    filled = true,
}) => {
    const blue = "#1e355f";
    const primary = "#55bec1";
    const transparent = "transparent";
    const fill1 = filled ? blue : transparent;
    const fill2 = filled ? primary : transparent;
    const stroke1 = filled ? transparent : blue;
    const stroke2 = filled ? transparent : primary;

    return (
        <svg
            className={className}
            id="b5777bdb-60ae-4921-a6e0-b23872bff102"
            data-name="Livello 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 82 82"
            width="100px"
            height="100px"
        >
            <defs>
                <style>
                    {`
                .first {
                    fill: ${fill1}; 
                    stroke: ${stroke1};
                }
                
                .second {
                    fill: ${fill2}; 
                    stroke: ${stroke2};
                }
            `}
                </style>
            </defs>
            <rect
                className="first"
                x="13.6658"
                y="17.4353"
                width="21.251"
                height="21.251"
            />
            <polygon
                className="first"
                points="34.412 26.478 47.85 27.978 34.412 29.478 34.412 26.478"
            />
            <rect
                className="first"
                x="48.4743"
                y="14.4917"
                width="16.0805"
                height="16.0805"
                transform="translate(79.0464 -33.9826) rotate(90)"
            />
            <polygon
                className="first"
                points="58.077 29.752 56.577 43.87 55.077 29.752 58.077 29.752"
            />
            <rect
                className="first"
                x="17.2587"
                y="50.2294"
                width="11.3212"
                height="11.3212"
                transform="translate(-32.9707 78.8092) rotate(-90)"
            />
            <polygon
                className="first"
                points="21.375 50.87 22.875 39.085 24.375 50.87 21.375 50.87"
            />
            <rect
                className="second"
                x="44.8714"
                y="44.0455"
                width="23.4628"
                height="23.4628"
                transform="translate(113.2055 111.5538) rotate(180)"
            />
            <polygon
                className="second"
                points="45.72 57.369 29.297 55.869 45.72 54.369 45.72 57.369"
            />
        </svg>
    );
};

export default FlowentiIcon;